
<template>
    <page>
        <module title="平台规则" enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="标题">
                    <c-input name="name" placeholder="请输入搜索关键字"></c-input>
                </m-search-item>
            </m-search>

            <div class="ruleInfo">
                <div v-for="(item,index) in list" :key="item.id" class="rule-card"  @click="goToDetail(item)">
                    <c-file media :src="item.video_url||item.img_url" class="rule-file" :preview="false"></c-file>
                    <div class="rule-title">{{item.name}}</div>
                </div>
                <div v-if="list.length==0" style="width:100%;height:800px;">
                    <Empty type="rule"></Empty>
                </div>
            </div>

        </module>
        <pagination
                ref="pagination"
                :total="total"
                :border="true"
                @handle="searchHandle"
                :size="10">
        </pagination>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import MSearchItem from "@/components/module/search_item.vue";
export default {
    name: 'm_platform_rule',
    components: {
        MSearchItem,
        Pagination: () => import('@/submodule/components/public/pagination'),
        Empty: () => import('@/submodule/components/public/empty'),
    },

    props: {
        tab: String
    },

    data() {
        return {
            list: [],
            total: 0,
            currentPage: 1,
        }
    },

    computed: {
        ...mapState(['userInfo']),
    },

    mounted() {
        this.$refs.search.search();
    },

    methods: {
        searchHandle(data) {
            // 平台规则,固定传参
            data.type_id = -2;
            data.state = [2];
            this.request({
                url: '/abstract_consultation/list',
                data: {
                    ...data,
                    pageIndex: data.pageIndex || 1,
                    pageSize: data.pageSize || 10
                },
                loading: true,
                success: (obj) => {
                    this.list = obj;
                },
                response: res => {
                    this.total = res.total;
                }
            })
        },
        goToDetail(item) {
            this.navigateTo(`/help_detail/${item.id}`);
        }
    }
}
</script>

<style scoped>
.ruleInfo{
    display: flex;
    flex-wrap: wrap;
}
.rule-title {
    text-align: left;
    height: 40px;
    padding: 8px;
    background-color: #F5F5F5;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}
.rule-card {
    width: 300px;
    margin: 20px;
    cursor: pointer;
}
.rule-file {
    width:300px;
    height:180px;
    border: none;
}
</style>